import React from "react";
import { Modal } from "@aph/ui-lib-humanx";
import { HOME_TYPE } from "@/components/PageHome/api/interface";
import PreconceptionFlow from "@/components/PageHome/components/OnboardingSection/Flows/Preconception";
import PregnancyFlow from "@/components/PageHome/components/OnboardingSection/Flows/Pregnancy";
import BirthFlow from "@/components/PageHome/components/OnboardingSection/Flows/Birth";
import NewMomFlow from "@/components/PageHome/components/OnboardingSection/Flows/NewMom";
import styles from "@/components/PageHome/components/OnboardingSection/Onboarding.module.scss";
import { DeviceInfo } from "@/interface/deviceInfo";

interface FlowProps {
  currentFlow?: `${HOME_TYPE}`;
  isOpen: boolean;
  onClose?: () => void;
  handleModelOpen?: () => void;
  userAgent?: DeviceInfo;
}

const OnboardingFlow: React.FC<FlowProps> = ({ currentFlow, isOpen, onClose, handleModelOpen, userAgent }) => {
  return (
    <Modal
      size="md"
      backdropClose
      mobileBottomAlign
      titleAlign="center"
      open={isOpen}
      handleOpen={(modalStatus: boolean): void => {
        if (modalStatus === false && onClose && typeof onClose === "function") {
          onClose();
        }
      }}
      isHXModal
      modalClass={styles.modalClass}
      titleClass={styles.titleClass}
      modalboxClass={styles.modalboxClass}
      modalContentClass={styles.innerSection}
    >
      {currentFlow === HOME_TYPE.PRECONCEPTION && (
        <PreconceptionFlow isModalOpen={isOpen} setIsModalOpen={handleModelOpen} userAgent={userAgent} />
      )}

      {currentFlow === HOME_TYPE.PREGNANCY && (
        <PregnancyFlow isModalOpen={isOpen} setIsModalOpen={handleModelOpen} userAgent={userAgent} />
      )}
      {currentFlow === HOME_TYPE.BIRTH && (
        <BirthFlow isModalOpen={isOpen} setIsModalOpen={handleModelOpen} userAgent={userAgent} />
      )}
      {currentFlow === HOME_TYPE.NEW_MOM && (
        <NewMomFlow isModalOpen={isOpen} setIsModalOpen={handleModelOpen} userAgent={userAgent} />
      )}
    </Modal>
  );
};

export default OnboardingFlow;
